/**
 * 试用 / 联系表单的投递方式：不经过任何后端。
 *
 * 两条路都留给用户选：`mailto:` 让浏览器唤起本机邮件客户端；一键复制则把正文
 * 放进剪贴板，方便用网页邮箱粘贴。选择权在用户手里，所以两条都要能用。
 */
import { BRAND } from '@/content/site';

export function buildMailtoHref(subject: string, body: string, to: string = BRAND.email): string {
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/**
 * `mailto:` 在不同客户端上的长度上限差别很大，超过这个长度就只提供复制。
 */
export const MAILTO_SAFE_LENGTH = 1800;

export function isMailtoUsable(href: string): boolean {
  return href.length <= MAILTO_SAFE_LENGTH;
}

/** 剪贴板 API 在非安全上下文或旧浏览器里不可用，退回到临时 textarea。 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* 继续走兜底路径 */
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}

export function mailtoLabel(): string {
  return `写信到 ${BRAND.email}`;
}
